import {onDomReady} from "./observer.js";

class Header {
    constructor() {
        this.options = {
            entirePage: '[data-body]',
            headerLangButtonDesktop: '[data-header-lang-button-desktop]',
            headerLangWindowDesktop: '[data-header-lang-window-desktop]',
            headerLangWindowDesktopCurrent: '[data-header-lang-window-desktop-current]',
            headerBurger: '[data-header-burger]',
            headerBurgerOverlay: '[data-header-burger-overlay]',
            headerBurgerButton: '[data-header-burger-button]',
            headerBurgerProfileButton: '[data-header-burger-profile-button]',
            headerBurgerLanguage: '[data-header-burger-language]',
            headerBurgerLanguages: '[data-header-burger-languages]',
            headerBurgerLanguagesClose: '[data-header-burger-languages-close]',
            headerBurgerLanguagesCurrent: '[data-header-burger-languages-current]',
            headerSearchOpener: '[data-header-search-opener]',
            headerSearchWrapper: '[data-header-search-wrapper]',
            headerSearchInput: '[data-header-search-input]',
            headerSearchWrapperOpened: 'header__menu-wrapper_search',
            headerBurgerButtonOpened: 'header__block_burger-opened',
            headerBurgerProfileButtonOpened: '_opened',
            headerBurgerOpened: 'header__burger_opened',
            headerBurgerLanguagesOpened: 'header__burger-languages_opened',
            headerBurgerOverlayOpened: 'header__burger-overlay_opened',
            headerBurgerProfileMode: 'header__burger_profile-active',
            headerLangButtonDesktopOpened: '_opened',
            noScroll: 'body-fixed',
        };

        this.elements = {
            headerLangWindowDesktopCurrentElement: document.querySelector(this.options.headerLangWindowDesktopCurrent),
            headerLangWindowDesktopElement: document.querySelector(this.options.headerLangWindowDesktop),
            headerLangButtonDesktopElement: document.querySelector(this.options.headerLangButtonDesktop),
            headerBurgerOverlayElement: document.querySelector(this.options.headerBurgerOverlay),
            headerBurgerElement: document.querySelector(this.options.headerBurger),
            entirePageElement: document.querySelector(this.options.entirePage),
            headerBurgerButtonElement: document.querySelector(this.options.headerBurgerButton),
            headerBurgerProfileButtonElement: document.querySelector(this.options.headerBurgerProfileButton),
            headerBurgerLanguageElement: document.querySelector(this.options.headerBurgerLanguage),
            headerBurgerLanguagesElement: document.querySelector(this.options.headerBurgerLanguages),
            headerBurgerLanguagesCloseElement: document.querySelector(this.options.headerBurgerLanguagesClose),
            headerBurgerLanguagesCurrentElement: document.querySelector(this.options.headerBurgerLanguagesCurrent),
            headerSearchOpenerElement: document.querySelector(this.options.headerSearchOpener),
            headerSearchInputElement: document.querySelector(this.options.headerSearchInput),
            headerSearchWrapperElement: document.querySelector(this.options.headerSearchWrapper),
        };

        this.init();
    }

    init() {

        if (this.elements.headerLangButtonDesktopElement &&
            this.elements.headerLangWindowDesktopElement &&
            this.elements.headerLangWindowDesktopCurrentElement) {
            const LangButtonDesktop = this.elements.headerLangButtonDesktopElement;
            const LangWindowDesktopCurrent = this.elements.headerLangWindowDesktopCurrentElement;
            const LangWindowDesktop = this.elements.headerLangWindowDesktopElement;
            LangButtonDesktop.addEventListener('click', () => {
                LangButtonDesktop.classList.toggle(this.options.headerLangButtonDesktopOpened);
            });
            LangWindowDesktop.addEventListener('click', function(event) {
                event.stopPropagation();
            });
            LangWindowDesktopCurrent.addEventListener('click', () => {
                LangButtonDesktop.classList.remove(this.options.headerLangButtonDesktopOpened);
            });
            let closeLangDesktop;
            this.elements.headerLangWindowDesktopElement.addEventListener("mouseenter", () => {
                clearTimeout(closeLangDesktop);
            });
            this.elements.headerLangWindowDesktopElement.addEventListener("mouseleave", () => {
                closeLangDesktop = setTimeout(() => {
                    LangButtonDesktop.classList.remove(this.options.headerLangButtonDesktopOpened);
                }, 1100);
            });
        }
        if (this.elements.headerSearchOpenerElement &&
            this.elements.headerSearchWrapperElement &&
            this.elements.headerSearchInputElement) {
            const searchButtonMobile = this.elements.headerSearchOpenerElement;
            const searchContainerMobile = this.elements.headerSearchWrapperElement;
            const searchInputMobile = this.elements.headerSearchInputElement;
            searchButtonMobile.addEventListener('click', () => {
                searchContainerMobile.classList.toggle(this.options.headerSearchWrapperOpened);
                if (searchContainerMobile.classList.contains(this.options.headerSearchWrapperOpened)) {
                    searchInputMobile.focus();
                }
            });
        }
        if (this.elements.headerBurgerButtonElement &&
            this.elements.headerBurgerProfileButtonElement &&
            this.elements.entirePageElement &&
            this.elements.headerBurgerElement) {
            const burger = this.elements.headerBurgerElement;
            const burgerButton = this.elements.headerBurgerButtonElement;
            const burgerProfileButton = this.elements.headerBurgerProfileButtonElement;
            const entirePage = this.elements.entirePageElement;

            window.addEventListener('resize', () => {
                if (burger &&
                    burgerButton &&
                    burgerProfileButton &&
                    this.options.headerBurgerOpened &&
                    this.options.headerBurgerButtonOpened &&
                    this.options.headerBurgerProfileButtonOpened) { // todo: not check for opened is defined?
                        burger.style.left = "";
                        burger.classList.remove(this.options.headerBurgerOpened);
                        burgerButton.classList.remove(this.options.headerBurgerButtonOpened);
                        burgerProfileButton.classList.remove(this.options.headerBurgerProfileButtonOpened);
                }
            });

            burgerButton.addEventListener('click', () => {
                burgerButton.classList.toggle(this.options.headerBurgerButtonOpened);
                if (burgerButton.classList.contains(this.options.headerBurgerButtonOpened)) {
                    burger.classList.remove(this.options.headerBurgerProfileMode);
                    if (burgerProfileButton.classList.contains(this.options.headerBurgerProfileButtonOpened)) {
                        burgerProfileButton.classList.remove(this.options.headerBurgerProfileButtonOpened);
                    }
                    else {
                        entirePage.classList.add(this.options.noScroll);
                        burger.classList.add(this.options.headerBurgerOpened);
                    }
                }
                else {
                    entirePage.classList.remove(this.options.noScroll);
                    burger.classList.remove(this.options.headerBurgerOpened);
                }
            });
            burgerProfileButton.addEventListener('click', () => {
                burgerProfileButton.classList.toggle(this.options.headerBurgerProfileButtonOpened);
                if (burgerProfileButton.classList.contains(this.options.headerBurgerProfileButtonOpened)) {
                    burger.classList.add(this.options.headerBurgerProfileMode);
                    if (burgerButton.classList.contains(this.options.headerBurgerButtonOpened)) {
                        burgerButton.classList.remove(this.options.headerBurgerButtonOpened);
                    }
                    else {
                        if (window.innerWidth > 1200) {
                            burger.style.left = (burgerProfileButton.getBoundingClientRect().right - 370) + 'px';
                            entirePage.classList.remove(this.options.noScroll);
                            let closeProfileDesktop;
                            burger.addEventListener("mouseenter", () => {
                                clearTimeout(closeProfileDesktop);
                            });
                            burger.addEventListener("mouseleave", () => {
                                if (window.innerWidth > 1200) {
                                    closeProfileDesktop = setTimeout(() => {
                                        burger.classList.remove(this.options.headerBurgerOpened);
                                        burgerButton.classList.remove(this.options.headerBurgerButtonOpened);
                                        burgerProfileButton.classList.remove(this.options.headerBurgerProfileButtonOpened);
                                    }, 1100);
                                }
                            });
                        }
                        else {
                            burger.style.left = "";
                            entirePage.classList.add(this.options.noScroll);
                        }
                        burger.classList.add(this.options.headerBurgerOpened);
                    }
                }
                else {
                    entirePage.classList.remove(this.options.noScroll);
                    burger.classList.remove(this.options.headerBurgerOpened);
                }
            });
        }
        if (this.elements.headerBurgerLanguageElement &&
            this.elements.headerBurgerLanguagesElement &&
            this.elements.headerBurgerLanguagesCloseElement &&
            this.elements.headerBurgerLanguagesCurrentElement &&
            this.elements.headerBurgerOverlayElement) {
            const burgerOverlay = this.elements.headerBurgerOverlayElement;
            const burgerLanguage = this.elements.headerBurgerLanguageElement;
            const burgerLanguages = this.elements.headerBurgerLanguagesElement;
            const burgerLanguagesClose = this.elements.headerBurgerLanguagesCloseElement;
            const burgerLanguagesCurrent = this.elements.headerBurgerLanguagesCurrentElement;
            burgerLanguagesClose.addEventListener('click', () => {
                burgerLanguages.classList.remove(this.options.headerBurgerLanguagesOpened);
                burgerOverlay.classList.remove(this.options.headerBurgerOverlayOpened);
            });
            burgerLanguagesCurrent.addEventListener('click', () => {
                burgerLanguages.classList.remove(this.options.headerBurgerLanguagesOpened);
                burgerOverlay.classList.remove(this.options.headerBurgerOverlayOpened);
            });
            burgerLanguage.addEventListener('click', () => {
                burgerOverlay.classList.add(this.options.headerBurgerOverlayOpened);
                burgerLanguages.classList.toggle(this.options.headerBurgerLanguagesOpened);
            });
            burgerOverlay.addEventListener('click', () => {
                burgerLanguages.classList.remove(this.options.headerBurgerLanguagesOpened);
                burgerOverlay.classList.remove(this.options.headerBurgerOverlayOpened);
            });
        }
    }
}

onDomReady(() => {
    const header = new Header();
}, false);